import * as React from "react";
import Select from "react-select";
import classNames from "classnames";

// Styles
import CustomStyles from "./InputSelect.config";
import "./InputSelect.scss";

interface InputSelectRegister {
  id: string;
  label: string;
  options: any[];
  value: any;
  required?: boolean;
  placeholder: string;
  loading: boolean;
  className?: string;
  onChange: (field: string, value: any) => void;
  onBlur: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean
  ) => void;
}

const InputSelectRegister: React.FC<InputSelectRegister> = (
  props: InputSelectRegister
) => {
  const {
    id,
    label,
    options,
    value,
    required,
    placeholder,
    loading,
    className,
    onChange,
    onBlur,
  } = props;

  const handleChange = (value: any) => onChange(id, value);

  const handleBlur = () => onBlur(id, true);

  const selectClassNames = classNames("input-select", {
    [`${className}`]: className,
  });

  return (
    <div className={selectClassNames}>
      <label htmlFor={id}>{label}</label>
      <Select
        id={id}
        options={options}
        styles={CustomStyles}
        placeholder={placeholder}
        isSearchable={false}
        onChange={handleChange}
        onBlur={handleBlur}
        required={required}
        isLoading={loading}
        value={value && Object.keys(value).length === 0 ? "" : value}
      />
      <input
        className="input-select--hidden"
        value={value && Object.keys(value).length === 0 ? "" : value}
        onChange={handleChange}
        required={required}
      />
    </div>
  );
};

export default InputSelectRegister;
